import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import InputBox from "../../../common/interactive/InputBox"
import PannelBody from "../../../fragments/PannelBody"
import { caseQuickUpdate, createLawFirmNegotiator, editLawFirmNegotiator, getPostalInformation, selectLawFirm } from "../../../../lib/fetchApi"
import { applyPostalInformation, applyPostalFormState, applyManualStateChange } from "../../../../lib/postalInformation"
import { buildEntityFormContact } from "../../../../lib/countyResolution"
import { useContactCountyConfirmation } from "../../../patient/page/countyMismatchConfirm"
import { notificationActions } from "../../../../store/notifications"
import { countiesOptions, stateOptions } from "../../../../lib/systemData"
import FalseInputNumber from "../../../common/FalseInputNumber"
import { caseActions } from "../../../../store/case"
import { phoneFormat } from "../../../../lib/script"
import PannelFooter from "../../../fragments/PannelFooter"
import CustomSelect from "../../../common/interactive/CustomSelect"

import classes from './Create.module.css'
import { isCompletePhone, isEmail } from "../../../../lib/validation"

const CreateLawFirmNegotiatorForm = ({closeModal, firmData, edit, negotiator}) => {

    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)

    const activeCase = useSelector(state => state.case.activeCase)
    const { confirmCountyOnSave, modal: countyMismatchModal } = useContactCountyConfirmation()

    const [counties, setCounties] = useState(null)
    const [selectedCity, setSelectedCity] = useState(null)
    const statesOptionsData = useMemo(() => stateOptions(), [])

    const createLawFirmHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)

        try {
            const fd = new FormData(event.target)

            const data = Object.fromEntries(fd.entries())

            let errors = []
                            
            if (data && data.email && !isEmail(data.email)) {
                errors.push('Please check Email Field')
            } 

            if (data && data.phone && !isCompletePhone(data.phone)) {
                errors.push('Please check Phone Field')
            }

            if (data && data.cell_phone && !isCompletePhone(data.cell_phone)) {
                errors.push('Please check Cell Phone Field')
            }

            if (data && data.fax && !isCompletePhone(data.fax)) {
                errors.push('Please check Fax Field')
            }

            if (errors && !errors.length) {
                const originalContact = edit ? negotiator?.contact_information : null
                const formContact = buildEntityFormContact(data)
                const countyResult = await confirmCountyOnSave({
                    token: userToken,
                    originalContact,
                    formContact,
                    selectedCountyId: data.county,
                    selectedCountyLabel: selectedcounty?.label ?? '',
                    countiesOptions,
                    onSuggestedCounty: setSelectedcounty,
                })

                if (countyResult?.error) {
                    dispatch(notificationActions.setError(countyResult.error))
                    return
                }

                if (countyResult.cancelled) {
                    return
                }

                const body = {
                    first_name: data.attorney_first_name,
                    last_name: data.attorney_last_name,
                    law_firm_id: firmData.law_firm_id,
                    contact_information: {
                        email: data.email,
                        phone: data.phone,
                        cell_phone: data.cell_phone,
                        phone_2: null,
                        phone_3: null,
                        phone_ext: data.ext,
                        fax: data.fax,
                        address_1: data.address_line_1,
                        address_2: data.address_line_2,
                        city: data.city,
                        state: data.state,
                        county_id: countyResult.countyId,
                        zip: data.zip_code
                    }
                }

                let lawFirmattorney;
                if (edit) { //edit api
                    lawFirmattorney = await editLawFirmNegotiator(userToken, negotiator.id, body)
                } else { //create api
                    lawFirmattorney = await createLawFirmNegotiator(userToken, body)
                }         

                if (lawFirmattorney?.errorMessage) {
                    dispatch(notificationActions.setError(lawFirmattorney))     
                } else {           
                    // clsoe modal 
                    closeModal()

                    // DO SOMETHINNG WITH THE FIRM?
                    dispatch(caseActions.modifyActiveCaseMultiple({
                        folder: 'attorneys',
                        item: {
                            itemId: firmData.id,
                            fields: [
                                {
                                    field: 'negotiator_id',
                                    value: lawFirmattorney?.id
                                },
                                {
                                    field: 'negotiator',
                                    value: lawFirmattorney
                                }
                            ]              
                        },
                    }))

                    //need to re make the all reps array
                    let repsFromlawFirm =  await selectLawFirm(userToken, firmData.law_firm_id)
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: firmData.id,
                        folder: 'attorneys',
                        content: repsFromlawFirm
                    }))

                    // if it is not on edit modes, need to bind the created entity to the law firm
                    if (!edit) {
                        let reqBody = {
                            type: 'case_attorney',
                            type_id: firmData.id,
                            fields: {
                                negotiator_id: lawFirmattorney?.id,
                            }
                        }
                        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)
                        if (update?.errorMessage) {
                            dispatch(notificationActions.setError(lawFirmattorney))     
                        } else {
                            dispatch(notificationActions.setError({errorMessage: 'Binded to law firm', type:'success'}))
                            
                        }
                    }

                    //and then set the newly craeted negotiator
                    // let reqBody = {
                    //     type: `case_negotiation`,
                    //     fields: {
                    //         entity_type: 'Negotiator',
                    //         entity_type_id: lawFirmattorney.id
                    //     }
                    // }     
            
                    // const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)
            
                    // if (update && update.errorMessage) {            
                    //     dispatch(notificationActions.setError(update))
                    // } else {
                        
            
                    //     dispatch(caseActions.replaceWholeFolder({
                    //         folder: 'case_negotiation',
                    //         content: update
                    //     }))     
                    // } 
                }
            } else {
                dispatch(notificationActions.setError({errorMessage : errors}))
            }
        } finally {
            setIsLoading(false)
        }
    }

    const selectStatehandler = (value) => {
        applyManualStateChange({
            stateValue: value.data.value,
            stateOption: value.option,
            setCounties,
            setSelectedState,
            setSelectedcounty,
            countiesOptions,
            statesOptions: statesOptionsData,
        })
    }

    const selectCountyHandler = (value) => {
        setSelectedcounty(value.option)
    }


    const [selectedState, setSelectedState] = useState(null)
    const [selectedcounty, setSelectedcounty] = useState(null)

    useEffect(() => {
        if (edit) {
            let selectedState = statesOptionsData.find(item => item.value == negotiator.contact_information.state)
            setTimeout(() => {
                setSelectedState(selectedState)
            }, 200);
            

            let counties = countiesOptions().filter(item => item.state == negotiator.contact_information.state)
            setTimeout(() => {
                setCounties(counties)
            }, 200);

            let county = countiesOptions().find(item => item.value == negotiator.contact_information.county_id)

            if (county) {
                setTimeout(() => {
                    setSelectedcounty(county)
                }, 300);
            }

            setSelectedCity(edit ? negotiator.contact_information.city : null)
        }
    }, [edit, firmData])

    async function retrievePostalInformation(value) {
        setIsLoading(true)
        try {
        if (value && value.data?.value && value.data.value.length == 5) {
            let body = {
                zip : value.data.value
            }
            let postalInformation = await getPostalInformation(userToken, body)

            if (postalInformation && postalInformation.zip) {
                const result = applyPostalInformation({
                    postalInformation,
                    previousState: selectedState?.value,
                    previousCounty: selectedcounty,
                    statesOptions: statesOptionsData,
                    countiesOptions,
                })

                applyPostalFormState({
                    result,
                    setSelectedState,
                    setSelectedCity,
                    setCounties,
                    setSelectedcounty,
                })
            } else {
                dispatch(notificationActions.setError({errorMessage: 'No information found for the provided zipcode'}))
            }
        }
        } finally {
            setIsLoading(false)
        }
    }

    return <form onSubmit={createLawFirmHandler}>
        {countyMismatchModal}
        <PannelBody padding='large' background={'var(--line-transparent)'}>
            <div className={classes.subtitle}>
                Assigned Law Firm
            </div>
            {firmData.law_firm.name}
        </PannelBody>
        <PannelBody>
            <div className={classes.inner_title}>
                <h3>Contact Information</h3>
            </div>
            <div className={classes.name_container}>
                <InputBox label="First name" type="text" name="attorney_first_name" required={true} placeholder="" currentValue={edit ? negotiator.first_name : null}/>
                <InputBox label="Last name" type="text" name="attorney_last_name" required={true} placeholder="" currentValue={edit ? negotiator.last_name : null}/>
            </div>
            <InputBox label="Email" type="email" name="email" required={true} placeholder="" icon={'ti ti-mail'} currentValue={edit ? negotiator.contact_information.email : null}/>
            <div className={classes.phone_container}>
                <InputBox label="Phone" type="text" name="phone" required={true} placeholder="" icon={'ti ti-phone'} currentValue={edit ? phoneFormat(negotiator.contact_information.phone) : null} format={'phone'}/>
                <InputBox label="Ext" type="text" name="ext" required={false} placeholder="" currentValue={edit ? negotiator.contact_information.phone_ext : null}/>
            </div>
            <div className={`row`}>
                <InputBox label={'Cell Phone'} name={'cell_phone'} currentValue={edit ? phoneFormat(negotiator.contact_information.cell_phone) : null} format={'phone'}/>
            </div>
            <div className="row">
                <InputBox label="Fax" type="text" name="fax" required={true} placeholder="" currentValue={edit ? phoneFormat(negotiator.contact_information.fax) : null} format={'phone'}/>
            </div>
            <div className="row">
                <InputBox label="Address Line 1" type="text" name="address_line_1" required={false} placeholder="" currentValue={edit ? negotiator.contact_information.address_1 : null}/>
            </div>
            <div className="row">
                <InputBox label="Address Line 2 (Optional)" type="text" name="address_line_2" required={false} placeholder="" currentValue={edit ? negotiator.contact_information.address_2 : null}/>
            </div>
            <div className={classes.grid}>      

                <InputBox label="Zip Code" type="text" name="zip_code" required={false} placeholder="" currentValue={edit ? negotiator.contact_information.zip : null} format={'zip'} action={retrievePostalInformation}/>         
                <InputBox label="City" type="text" name="city" required={false} placeholder="" currentValue={selectedCity} action={(value) => setSelectedCity(value.data.value)}/>

                <CustomSelect label={`State`} optionsData={statesOptionsData} action={selectStatehandler} preSelectedValue={selectedState?.value} name={'state'} reverseDrawer={true}/>
               

                {counties?.length > 0 && <CustomSelect key={selectedState?.value ?? 'county'} label={'County'} optionsData={counties} preSelectedValue={selectedcounty?.value} name={'county'} action={selectCountyHandler} reverseDrawer={true} rtlDrawer={true}/>}

                {(!counties || counties.length === 0) && <FalseInputNumber label={'County'}/>}

                
            </div>

        </PannelBody>
        <PannelFooter>
            <Button type='submit' isLoading={isLoading} width={'full'}>
                Submit 
                <i className="ti ti-chevron-right"></i>
            </Button>
        </PannelFooter>
    </form>
}

export default CreateLawFirmNegotiatorForm